import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle, FaSignOutAlt, FaUser } from 'react-icons/fa';
import { supabase } from '../supabaseClient';
import '../styles/styles.css';

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (mounted) {
        setIsLoggedIn(!!session);
        setUser(session?.user || null);
      }
    };

    checkSession();

    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      if (mounted) {
        setIsLoggedIn(!!session);
        setUser(session?.user || null);
      }
    });

    return () => {
      mounted = false;
      authListener?.subscription?.unsubscribe();
    };
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleEditProfile = () => {
    navigate('/edit-profile');
  };

  return (
    <header className="header">
      <div className="header-content">
        <div 
          className="logo animate-fade-in" 
          onClick={handleLogoClick}
          role="button"
          tabIndex={0}
        >
          🚗 DOCTOR OIL
        </div>
        
        <div className="user-menu">
          {isLoggedIn && user && (
            <span className="text-secondary text-sm hidden md:block mr-4">
              {user.email}
            </span>
          )}

          {isLoggedIn && (
            <button
              className="auth-button profile"
              onClick={handleEditProfile}
              title="Editar perfil"
            >
              <FaUserCircle size={20} />
            </button>
          )}
          
          {isLoggedIn ? (
            <button
              className="auth-button logout"
              onClick={handleLogout}
              title="Cerrar sesión"
            >
              <FaSignOutAlt size={16} />
              <span className="auth-text hidden md:inline">Cerrar sesión</span>
            </button>
          ) : (
            <button
              className="auth-button icon-only login"
              onClick={handleLogin}
              title="Acceso empleados"
            >
              <FaUser size={20} />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;